module.exports = __webpack_public_path__ + "img/wu-250x180f_10.prt.2a14fb88.jpg";